import {
  _IDLE,
  _BUSY,
  _ALERT_TYPES,
  _API_CALLED,
  _DOWNLINE_SEARCH,
  _DOWNLINE_QUERY,
  _SET_Y,
  _SET_PAGESIZE,
  _SET_ACTIVE_TAB,
  _IS_KEEPED_LOGIN,
  _GAME_SEARCH,
  _GAME_QUERY,
  _BIND_MEMBER,
  _IS_SHOW_LOGIN,
  _IS_SHOW_REGISTER,
  _IS_SHOW_FORGOT_PASSWORD,
  _IS_SHOW_CREATE_SHARE_HOLDER_PIN,
  _IS_SHOW_CREATE_SHARE_HOLDER_PIN_POPUP,
  _IS_SHOW_VERIFY_SHARE_HOLDER_PIN,
  _IS_SHOW_COMMUNICATION_CHANNEL,
  _COMMUNICATION_CHANNEL_LIST,
  _RTP_URL,
  _IS_SHOW_PROFILE,
  _IS_NON_SEAMLESS_GAME_EXIST,
  _CHECK_DAILY_CHECK_IN,
  _BANNER_POPUP_MODAL,
  _BANNER_POPUP_IMAGE,
  _PRODUCT_CATEGORY_GAME_LIST,
  _UNCLAIM_COMMISSION,
  _GRAND_TOTAL_REWARDS,
  _GAME_POINTS,
  _GAMES_93_CONNECT,
  _UNREAD_NOTIFICATION,
  _IS_SHOW_BIG_WINNING,
  _IS_PLATINUM,
  _SET_TELEGRAM_BOT_STATUS,
  _SET_TELEGRAM_BANNER_SECONDARY,
  _ANGPAO_STATUS,
  _SHOW_ANGPAO_TNC,
  _FIFA_STATUS,
  _FREE_SPIN_COUNT,
} from './AppAction';
import { stringIsNullOrEmpty } from '../util/Util';
import i18n from "../localization/i18n";
import { AlertTypes } from '../util/Constant';

const _INITIAL_STATE = {
  isBusy: false,
  isKeepedLogin: false,
  message: i18n.t("LOADING"),
  alert: {
  },
  iconEnabled: true,
  apiCalledResponse: {},
  savedText: "",
  gameSavedText: "",
  savedQuery: "/Member/GetUserMemberList?directUserOnly=true",
  gameQuery: "/Game/GetMasterProductGroupedGame",
  y: 0,
  pageSize: 10,
  activeTab: 0,
  walletBalance: 0,
  member: [],
  isShareholder: false,
  isShowLogin: false,
  isShowRegister: false,
  isShowLiveChat: false,
  isShowForgotPassword: false,
  isShowCreateShareHolderPin: false,
  isShowCreateShareHolderPinPopup: false,
  isShowVerifyShareHolderPin: false,
  rtpUrl: "https://taktikperangdewa.xyz/?lang=id",
  isShowCommunicationChannel: false,
  channelCommunicationList: [],
  isShowProfile: false,
  isNonSeamlessGameExist: true,
  isCheckedIn: false,
  bannerPopupModal: false,
  bannerPopupImage: [],
  productCategoryGameList: [],
  unclaimCommission: 0,
  unclaimCommissionList: [],
  grandTotalRewards: 0,
  gamePoints: 0,
  games93Connect: {},
  unreadNotification: 0,
  isPlatinum: false,
  telegramBotStatus: false,
  telegramBannerSecondary: [],
  angpaoStatus: null,
  showAngpaoTnc: null,
  fifaStatus: null,
  freeSpinCount: 0,
};

var _busyCount = 0;

/// <summary>
/// Author : 
/// </summary>
export default (state = _INITIAL_STATE, action) => {
  switch (action.type) {
    case _BUSY:
      _busyCount++;
      return {
        ...state,
        isBusy: true,
        message: stringIsNullOrEmpty(action.message) ? i18n.t("LOADING") : action.message,
        iconEnabled: action.iconEnabled == null ? _INITIAL_STATE.iconEnabled : action.iconEnabled,
      }
      break;
    case _IDLE:
      _busyCount = Math.max(--_busyCount, 0);
      return {
        ...state,
        isBusy: (_busyCount != 0),
      }
      break;
    case _ALERT_TYPES.SET_ALERT:
      state.alert.custom = true;
      state.alert.customIcon = action.alert.type == AlertTypes._INFO ? "/img/sweetalert_info.png" : action.alert.type == AlertTypes._SUCCESS ? "/img/sweetalert_success.png" : "/img/sweetalert_error.png";
      state.alert.content = action.alert.content;
      state.alert.onConfirm = action.alert.onConfirm;
      state.alert.onCancel = action.alert.onCancel;
      state.alert.cancelBtnBsStyle = action.alert.cancelBtnBsStyle;
      state.alert.title = action.alert.title;
      return {
        ...state,
        alert: Object.keys(state.alert) == 0 ? action.alert : state.alert
      };
      break;
    case _ALERT_TYPES.NONE:
      return {
        ...state,
        alert: {}
      };
      break;
    case _API_CALLED:
      return {
        ...state,
        apiCalledResponse: action.data
      };
      break;
    case _DOWNLINE_SEARCH:
      return {
        ...state,
        savedText: action.data
      };
      break;
    case _DOWNLINE_QUERY:
      return {
        ...state,
        savedQuery: action.data
      };
      break;
    case _GAME_SEARCH:
      return {
        ...state,
        gameSavedText: action.data
      };
      break;
    case _GAME_QUERY:
      return {
        ...state,
        gameQuery: action.data
      };
      break;
    case _SET_Y:
      return {
        ...state,
        y: action.y,
      };
    case _SET_PAGESIZE:
      return {
        ...state,
        pageSize: action.data,
      };
      break;
    case _SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.data,
      };
      break;
    case _IS_KEEPED_LOGIN:
      return {
        ...state,
        isKeepedLogin: action.data,
      };
      break;
    case _BIND_MEMBER:
      return {
        ...state,
        member: action.member,
        walletBalance: action.walletBalance,
      };
      break;
    case _IS_SHOW_LOGIN:
      return {
        ...state,
        isShowLogin: action.data
      };
      break;
    case _IS_SHOW_REGISTER:
      return {
        ...state,
        isShowRegister: action.data
      };
      break;
    case _IS_SHOW_COMMUNICATION_CHANNEL:
      return {
        ...state,
        isShowCommunicationChannel: action.data
      };
      break;
    case _COMMUNICATION_CHANNEL_LIST:
      return {
        ...state,
        communicationChannelList: action.data
      };
      break;
    case _IS_SHOW_FORGOT_PASSWORD:
      return {
        ...state,
        isShowForgotPassword: action.data
      };
      break
    case _IS_SHOW_CREATE_SHARE_HOLDER_PIN:
      return {
        ...state,
        isShowCreateShareHolderPin: action.data
      };
      break;
    case _IS_SHOW_CREATE_SHARE_HOLDER_PIN_POPUP:
      return {
        ...state,
        isShowCreateShareHolderPinPopup: action.data
      };
      break;
    case _IS_SHOW_VERIFY_SHARE_HOLDER_PIN:
      return {
        ...state,
        isShowVerifyShareHolderPin: action.data
      };
      break;
    case _RTP_URL:
      return {
        ...state,
        rtpUrl: action.data
      };
      break;
    case _IS_SHOW_PROFILE:
      return {
        ...state,
        isShowProfile: action.data
      };
      break;
    case _IS_NON_SEAMLESS_GAME_EXIST:
      return {
        ...state,
        isNonSeamlessGameExist: action.data
      };
      break;
    case _CHECK_DAILY_CHECK_IN:
      return {
        ...state,
        isCheckedIn: action.data,
      };
      break;
    case _BANNER_POPUP_MODAL:
      return {
        ...state,
        bannerPopupModal: action.data,
      };
      break;
    case _BANNER_POPUP_IMAGE:
      return {
        ...state,
        bannerPopupImage: action.data,
      };
      break;
    case _PRODUCT_CATEGORY_GAME_LIST:
      return {
        ...state,
        productCategoryGameList: action.data,
      };
      break;
    case _UNCLAIM_COMMISSION:
      return {
        ...state,
        unclaimCommission: action.data.totalClaimable,
        unclaimCommissionList: action.data.data,
      };
      break;

    case _GRAND_TOTAL_REWARDS:
      return {
        ...state,
        grandTotalRewards: action.data,
      };
      break;
    case _GAME_POINTS:
      return {
        ...state,
        gamePoints: action.data,
      };
      break;
    case _GAMES_93_CONNECT:
      return {
        ...state,
        games93Connect: action.data,
      };
      break
    case _UNREAD_NOTIFICATION:
      return {
        ...state,
        unreadNotification: action.data,
      };
      break;
    case _IS_SHOW_BIG_WINNING:
      return {
        ...state,
        isShowBigWinning: action.data
      };
      break;
    case _IS_PLATINUM:
      return {
        ...state,
        isPlatinum: action.data
      };
      break;
    case _SET_TELEGRAM_BOT_STATUS:
      return {
        ...state,
        telegramBotStatus: action.data
      };
      break;
    case _SET_TELEGRAM_BANNER_SECONDARY:
      return {
        ...state,
        telegramBannerSecondary: action.data
      };
      break;
    case _ANGPAO_STATUS:
      return { ...state, angpaoStatus: action.data };
    case _SHOW_ANGPAO_TNC:
      return { ...state, showAngpaoTnc: action.data };
    case _FIFA_STATUS:
      return { ...state, fifaStatus: action.data };
    case _FREE_SPIN_COUNT:
      return { ...state, freeSpinCount: action.data };
    default:
      return state;
      break;
  }
};